/** @format */

document.addEventListener('DOMContentLoaded', () => {
  const searchDrawer = document.querySelector('.search-drawer');
  const searchOpen = document.querySelectorAll("a[href='/search']");
  const searchClose = document.querySelector('.close-search-drawer');
  const searchOverlay = document.querySelector('#SearchDrawer-Overlay');

  searchOpen.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      searchDrawer.classList.add('active');
    });
  });

  searchClose.addEventListener('click', () => {
    searchDrawer.classList.remove('active');
  });

  searchOverlay.addEventListener('click', () => {
    searchDrawer.classList.remove('active');
  });
});
